import { Outlet } from "react-router-dom";
import { AuthProvider } from "@/providers/Auth";
import { ThemeProvider } from "@/providers/Theme";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BreadcrumbProvider } from "./providers/Breadcrumb";
import { ProviderElementsSelecteds } from "./providers/ElementsSelecteds";
import { PermittionProvider } from "./providers/Permition";
import { CookiesProvider } from "react-cookie";
import { BranchProvider } from "./providers/Branch";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export function Root() {
  return (
    <CookiesProvider>
      <AuthProvider>
        <ThemeProvider>
          <QueryClientProvider client={queryClient}>
            <BreadcrumbProvider>
              <PermittionProvider>
                <ProviderElementsSelecteds>
                  <BranchProvider>
                    <Outlet />
                  </BranchProvider>
                </ProviderElementsSelecteds>
              </PermittionProvider>
            </BreadcrumbProvider>
          </QueryClientProvider>
        </ThemeProvider>
      </AuthProvider>
    </CookiesProvider>
  );
}
